import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import QueryString from 'query-string';

import { GroupingsService } from '../../services';
import PageTitle from '../PageTitle/page_title';
import EventNotesReportForm from './event_notes_report_form';
import EventNotesReportEvents from './event_notes_report_events';
import i18next from "i18next";

const EventNotesReport = ({currentGrouping, location}) => {
  const [availableGroupingValues, setAvailableGroupingValues] = useState(null);
  const [query, setQuery] = useState(null);
  const [fromPrint, setFromPrint] = useState(false);
  const [printing, setPrinting] = useState(false);
  const [grouping, setGrouping] = useState(currentGrouping);

  useEffect(() => {
    const urlSearch = window.state ? QueryString.parse(location.search) : [];
    if (urlSearch["print"] === "true") {
      setQuery(window.state.query)
      setFromPrint(true);
      setPrinting(false);
    } else {
      setGrouping(null);
      setPrinting(false);
    }

    GroupingsService.listAll().then((response) => {
      const parentIds = response.groupings.map(grouping => grouping.parent ? grouping.parent.id : null);
      setAvailableGroupingValues(
        response.groupings
            .filter(grouping => grouping.parent !== null && !parentIds.includes(grouping.id))
            .map(grouping => ({ value: grouping.id, label: grouping.name, grouping: grouping }))
      );
    }).catch((error) => {
      // TODO setErrorMessage(i18next.t("messages.could-not-load-groupings"));
      console.error(error);
    });
  }, [location]);

  const handleSubmit = (data) => {
    event.preventDefault();
    setQuery(data);
  }

  const printClicked = () => {
    let printWindow = window.open(`${window.location.href}?print=true`, '_blank');
    printWindow.state = { query: query };
  }

  const eventsFetched = () => {
    if (fromPrint && !printing) {
      window.print();
      setPrinting(true);
    }
  }

  return availableGroupingValues ? 
    <div className="event-summary-report">
      <div className="row">
        <PageTitle title={ i18next.t('pages.event-notes-report.header') } />
      </div>
      <div className="device-detail-report">
        <div className="col-sm-12">
            <EventNotesReportForm
              groupingValues = { availableGroupingValues }
              onSubmit={handleSubmit}
              initData = {query}
              fromPrint = {fromPrint}
              showPrintButton={!fromPrint && query}
              printClicked={printClicked}
              groupingSelected={() => setQuery(null)}
            />
        </div>
      </div>
      { query && <EventNotesReportEvents query={query} grouping={grouping} dataFetched={eventsFetched} /> }
    </div>
    : 
    <div className="loader">{ i18next.t('loading') }</div>
}

export default connect(({currentGrouping}) => ({ currentGrouping: currentGrouping.currentGrouping}))(EventNotesReport);
